import { NgModule } from '@angular/core';
import { EmpusaMicroApp, EmpusaMicroAppType } from '@empusa/empusa-core';
import { AttachedAppHomeModule } from './attached.home.module';

@NgModule({
  declarations: [],
  imports: [],
  exports: []
})
export class AttachedAppModule implements EmpusaMicroApp {
  name: string = "attached-app";
  description: string = "Home Portal";
  icon: string = "attached-app";
  page: any = AttachedAppHomeModule;
  homeApp: boolean = false;
  path: string = "attached-app";
  order: number = 2;
  resourceServerId: string = "keycloak-auth-manager-resources-server";
  appType: EmpusaMicroAppType = EmpusaMicroAppType.normal;

  constructor() {
    //we register ourselves
    (<any>window).empusa(this);
    console.debug("Load microapp " + this.name);
  }
}
